import { positionRecoTeaserAside } from '@ts/utils/articleAsides/positionRecoTeaser';

export const placeRecoTeaser = () => {
  const recoTeaser = document.querySelector<HTMLElement>('.js-reco-teaser');
  if (!recoTeaser) return;

  const articleText = document.querySelector<HTMLElement>('.bo-article-text');
  if (!articleText) return;

  articleText.appendChild(recoTeaser);

  positionRecoTeaserAside(
    recoTeaser,
    articleText.firstElementChild as HTMLElement,
  );
};
